module.exports = "/static/assets/d81d8e89d3322c6270e5967a1711403f.png";